export const alphanumericValidator = (Language) => ({
  message: Language.get('common', 'NOT_VALID_ALPHANUMERIC'),
  validator: (_, value) => /[^a-z0-9-_.]+/i.test(value) ? Promise.reject() : Promise.resolve()
});
